(() => {
  const body = document.body;

  const overlay = document.querySelector('[data-drawer-overlay]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const facets = document.querySelector('[data-facets]');


  /*
  ==========================================
  OVERLAY
  ==========================================
  */

  const setOverlay = (open) => {
    if (!overlay) return;

    overlay.hidden = !open;
    body.classList.toggle('is-locked', open);
  };


  /*
  ==========================================
  ÎNCHIDERE MENIURI / DRAWERE
  ==========================================
  */

  const closeDrawers = () => {
    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');

    mobileMenu?.classList.remove('is-open');

    facets?.classList.remove('is-open');

    setOverlay(false);
  };


  /*
  ==========================================
  CLICKURI GENERALE
  ==========================================
  */

  document.addEventListener('click', (event) => {

    /*
    ------------------------------------------
    DESCHIDE COȘUL
    ------------------------------------------
    */

    const cartOpen = event.target.closest('[data-cart-open]');

    if (cartOpen) {
      event.preventDefault();

      cartDrawer?.classList.add('is-open');
      cartDrawer?.setAttribute('aria-hidden', 'false');

      setOverlay(true);
      refreshCart();

      return;
    }


    /*
    ------------------------------------------
    ÎNCHIDE MENIURI
    ------------------------------------------
    */

    const closeButton = event.target.closest(
      '[data-cart-close], [data-mobile-close], [data-filter-close]'
    );

    if (closeButton || event.target === overlay) {
      closeDrawers();
      return;
    }


    /*
    ------------------------------------------
    DESCHIDE MENIUL MOBIL
    ------------------------------------------
    */

    const mobileOpen = event.target.closest('[data-mobile-open]');

    if (mobileOpen) {
      mobileMenu?.classList.add('is-open');
      setOverlay(true);

      return;
    }


    /*
    ------------------------------------------
    DESCHIDE FILTRELE
    ------------------------------------------
    */

    const filterOpen = event.target.closest('[data-filter-open]');

    if (filterOpen) {
      facets?.classList.add('is-open');
      setOverlay(true);

      return;
    }


    /*
    ------------------------------------------
    LINKURI DIN MENIUL MOBIL

    IMPORTANT:
    NU folosim preventDefault().
    Linkul Shopify rămâne activ și duce direct
    la colecția respectivă.

    Exemplu:
    ROȘII -> /collections/seminte-rosii
    ------------------------------------------
    */

    const mobileCategoryLink = event.target.closest(
      '.mobile-menu__list a'
    );

    if (mobileCategoryLink) {
      /*
      Închidem doar meniul vizual.
      NU blocăm navigarea.
      */

      mobileMenu?.classList.remove('is-open');
      setOverlay(false);

      /*
      Nu punem return cu preventDefault.
      Browserul va urma normal href-ul.
      */

      return;
    }


    /*
    ------------------------------------------
    BUTOANE CANTITATE
    ------------------------------------------
    */

    const quantityButton = event.target.closest(
      '[data-quantity-change]'
    );

    if (quantityButton) {
      const input =
        quantityButton.parentElement.querySelector('input');

      if (!input) return;

      const change = Number(
        quantityButton.dataset.quantityChange
      );

      input.value = Math.max(
        Number(input.min || 1),
        Number(input.value || 1) + change
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      return;
    }


    /*
    ------------------------------------------
    ADAUGĂ OFERTĂ ÎN COȘ
    ------------------------------------------
    */

    const offerButton = event.target.closest(
      '[data-offer-add]'
    );

    if (offerButton) {
      event.preventDefault();

      addOffer(offerButton);

      return;
    }

  });


  /*
  ==========================================
  ADAUGĂ OFERTĂ ÎN COȘ
  ==========================================
  */

  const addOffer = async (button) => {
    const originalLabel = button.textContent;

    button.disabled = true;
    button.classList.add('loading');

    button.textContent = 'Se adaugă…';

    try {

      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',

          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(button.dataset.variantId),
                quantity: 1
              }
            ]
          })
        }
      );


      if (!response.ok) {
        throw new Error('Offer add failed');
      }


      button.classList.remove('loading');
      button.classList.add('is-added');

      button.textContent = 'Adăugat ✓';


      window.setTimeout(() => {
        window.location.reload();
      }, 550);


    } catch (error) {

      button.classList.remove('loading');

      button.textContent = 'Încearcă din nou';


      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalLabel;
      }, 1600);

    }
  };


  /*
  ==========================================
  ESCAPE
  ==========================================
  */

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawers();
    }
  });


  /*
  ==========================================
  FORMAT PREȚ
  ==========================================
  */

  const money = (cents) => {
    const currency =
      window.Shopify?.currency?.active || 'RON';

    return new Intl.NumberFormat(
      document.documentElement.lang || 'ro-RO',
      {
        style: 'currency',
        currency
      }
    ).format(cents / 100);
  };


  /*
  ==========================================
  ACTUALIZEAZĂ COȘUL
  ==========================================
  */

  const refreshCart = async () => {

    if (!cartDrawer) return;

    const container = cartDrawer.querySelector(
      '[data-cart-drawer-body]'
    );

    if (!container) return;


    try {

      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      const cart = await response.json();


      /*
      Actualizare număr produse
      */

      document
        .querySelectorAll('[data-cart-count]')
        .forEach((node) => {

          node.textContent = cart.item_count;

          node.hidden = cart.item_count === 0;

        });


      /*
      Coș gol
      */

      if (!cart.item_count) {

        container.innerHTML = `
          <p class="cart-drawer__empty">
            Coșul este gol. Hai să plantăm ceva frumos.
          </p>
        `;

        return;
      }


      /*
      Produsele din coș
      */

      const lines = cart.items
        .map((item) => `

          <div class="drawer-line">

            ${
              item.image
                ? `
                  <img
                    src="${item.image}"
                    alt=""
                  >
                `
                : '<div></div>'
            }

            <div>

              <h3>
                ${item.product_title}
              </h3>

              <span>
                ${item.quantity} × ${money(item.final_price)}
              </span>

            </div>

            <strong>
              ${money(item.final_line_price)}
            </strong>

          </div>

        `)
        .join('');


      /*
      Afișare coș
      */

      container.innerHTML = `

        ${lines}

        <div class="drawer-total">

          <span>
            Subtotal
          </span>

          <span>
            ${money(cart.total_price)}
          </span>

        </div>


        <a
          class="button button--full"
          href="${window.Shopify.routes.root}checkout"
        >
          Finalizează comanda
        </a>


        <a
          class="button button--outline button--full"
          style="margin-top:10px"
          href="${window.Shopify.routes.root}cart"
        >
          Vezi coșul
        </a>

      `;


    } catch (error) {

      container.innerHTML = `
        <p class="cart-drawer__empty">
          Coșul nu poate fi încărcat momentan.
        </p>
      `;

    }
  };


  /*
  ==========================================
  ADAUGĂ PRODUS ÎN COȘ
  ==========================================
  */

  document.addEventListener(
    'submit',
    async (event) => {

      const form = event.target.closest(
        '[data-product-form]'
      );

      if (!form) return;


      event.preventDefault();


      const button =
        form.querySelector('[type="submit"]');


      button?.classList.add('loading');


      try {

        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              Accept: 'application/json'
            },

            body: new FormData(form)
          }
        );


        if (!response.ok) {
          throw new Error('Add to cart failed');
        }


        await refreshCart();


        cartDrawer?.classList.add('is-open');

        cartDrawer?.setAttribute(
          'aria-hidden',
          'false'
        );


        setOverlay(true);


      } catch (error) {

        form
          .querySelector('[data-product-error]')
          ?.removeAttribute('hidden');


      } finally {

        button?.classList.remove('loading');

      }

    }
  );


  /*
  ==========================================
  SCHIMBARE VARIANTĂ PRODUS
  ==========================================
  */

  document
    .querySelectorAll('[data-product-select]')
    .forEach((select) => {

      select.addEventListener(
        'change',
        () => {

          const option =
            select.options[
              select.selectedIndex
            ];


          const form =
            select.closest('form');


          if (!form) return;


          const variantInput =
            form.querySelector('[name="id"]');


          if (variantInput) {
            variantInput.value =
              option.value;
          }


          const button =
            form.querySelector(
              '[type="submit"]'
            );


          if (button) {

            button.disabled =
              option.dataset.available !== 'true';


            button.textContent =
              option.dataset.available === 'true'
                ? 'Adaugă în coș'
                : 'Stoc epuizat';

          }


          const price =
            document.querySelector(
              '[data-product-price]'
            );


          if (price) {
            price.textContent =
              option.dataset.price;
          }


          const url =
            new URL(window.location.href);


          url.searchParams.set(
            'variant',
            option.value
          );


          history.replaceState(
            {},
            '',
            url.toString()
          );

        }
      );

    });


  /*
  ==========================================
  SORTARE COLECȚII
  ==========================================
  */

  document
    .querySelectorAll('[data-sort-by]')
    .forEach((select) => {

      select.addEventListener(
        'change',
        () => {

          const url =
            new URL(location.href);


          url.searchParams.set(
            'sort_by',
            select.value
          );


          location.href =
            url.toString();

        }
      );

    });


  /*
  ==========================================
  FILTRE COLECȚII
  ==========================================
  */

  document
    .querySelectorAll(
      '[data-facet-form] input'
    )
    .forEach((input) => {

      input.addEventListener(
        'change',
        () => {

          input.form?.submit();

        }
      );

    });

})();